import { useQuery } from '@tanstack/react-query';

import ProductsService from '@/services/ProductsService';

export const GET_PRODUCT_QUERY_KEY = (productId: number) => [
  'product',
  productId,
];

export function useGetProduct(productId: number) {
  const { data, isFetching } = useQuery({
    queryKey: GET_PRODUCT_QUERY_KEY(productId),
    queryFn: () => ProductsService.getProduct(productId),
  });

  return {
    product: data,
    isLoading: isFetching,
  };
}
